<lib-amdocs-checkbox [elementId]="item.code" [control]="checkboxCtrl"><ng-content></ng-content></lib-amdocs-checkbox>
